import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-modal-header',
  templateUrl: './custom-modal-header.component.html',
  styleUrls: ['./custom-modal-header.component.scss']
})
export class CustomModalHeaderComponent {
  @Input() title!: string;
  @Input() subtitle: string;
  @Input() showReturn: boolean = false;
  @Input() showDelete: boolean = false;

  @Output() onDeleteClick = new EventEmitter<number>();
  @Output() onCloseClick = new EventEmitter<number>();
  @Output() onReturnClick = new EventEmitter<number>();
}
